import React, { useEffect } from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { contentDataSelector } from '../../../../redux/selectors';
import { getFirst, getTextNotes } from '../../../../helpers/utilities';
import SingleColumnHalfWidthLayout from './SingleColumnHalfWidthLayout';
import TwoColumn6633Layout from './TwoColumn6633Layout';
import { usePlayAudio } from '../../../ui/AudioPlayer';
import { ContentItemContext } from '../../../../kentico/contentErrors';
export default function SingleQuestionPage({ page }) {
    const contentData = useAppSelector(contentDataSelector);
    const playAudio = usePlayAudio();
    const questionAudio = getFirst(page.elements.question_audio.linkedItems);
    const layout = getFirst(page.elements.page_layout.value).codename;
    const questionText = getFirst(page.elements.question.linkedItems).elements
        .question_text.value;
    const sectionHeader = page.elements.section_header.value;
    const inputChoices = page.elements.choices.linkedItems;
    const questionClarification = page.elements.subhead;
    const explanationText = page.elements.explanation_text;
    useEffect(() => {
        void playAudio({
            audio: getFirst(questionAudio.elements.audio_file.value).url,
            cc: getFirst(questionAudio.elements.cc.value).url,
        });
    }, [page, questionAudio, playAudio]);
    const { shortNote, fullText } = getTextNotes(page.elements.linked_text_note, contentData.plan);
    const sharedProps = {
        shortNote,
        fullText,
        sectionHeader,
        explanationText,
        questionClarification,
        inputChoices,
        questionText,
    };
    const Component = layout === 'single_column_half_width'
        ? SingleColumnHalfWidthLayout
        : TwoColumn6633Layout;
    return (React.createElement(ContentItemContext.Provider, { value: page },
        React.createElement(Component, { ...sharedProps })));
}
//# sourceMappingURL=SingleQuestionPage.js.map